import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import Pagination from "../../Common/Pagination/Pagination";
import AddPrivateLocalOrderDetails from "./AddPrivateLocalOrderDetails";
import UpdatePrivateLocalOrderDetail from "./UpdatePrivateLocalOrderDetail";
import { sweetAlert } from "../../Common/Utills/Utills";
import _ from "lodash";
import * as XLSX from "xlsx";

const ViewPrivateLocalDetails = () => {
  const [orderDetails, setOrderDetails] = useState([]);
  const params = useParams();
  const formRef = useRef(null);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowId, setRowId] = useState("");
  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [showSearch, setShowSearch] = useState(false);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const [company, setCompany] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [filterCriteria, setfilterCriteria] = useState({
    party_name: "",
    date: "",
  });

  const exportToExcel = (rowData) => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert rowData to a worksheet
    const ws = XLSX.utils.json_to_sheet(
      rowData.map((item, index) => ({
        "S.NO": (currentPage - 1) * pageSize + index + 1,
        "Company Name":
          item.companyDetails.company_name +
          ", " +
          item?.companyDetails?.location,
        "Product Name": item.productName.size,
        "Party Name": item.party_name,
        Date: item.date,
        "Received Date": item.received_date,
        "Order Quantity": item.total_order_qty,
        "Order Cost": item.cost,
        "Cost (GST Inclusive": item.cost_with_gst,
        Remarks: item.remarks,
      }))
    );

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Private Order Details");

    // Export the workbook
    XLSX.writeFile(wb, "Private_Order_Details.xlsx");
  };

  const handleFilterChange = (name, value) => {
    setfilterCriteria((prevFilterCriteria) => {
      return {
        ...prevFilterCriteria,
        [name]: value,
      };
    });
  };

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    // gridRef.current.api.showLoadingOverlay();
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    // gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const getData = async () => {
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );

    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    let BASE_URL =
      SERVER_URL + `/api/private-local/all-local-order-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(result.data);
    } else {
      setRowData([]);
    }
  };
  const deleteOrderNumberData = async (order_id) => {
    const message = "Do you want to delete this private order!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL =
      SERVER_URL +
      `/api/private-local/local-order-details/${user_id}/${order_id}`;
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(result.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
    }
  };
  useEffect(() => {
    const fecthDebounced = _.debounce(getData, 500);
    fecthDebounced();
    return () => {
      fecthDebounced.cancel();
    };
  }, [currentPage, pageSize, filterCriteria]);
  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);

  const addDataToModal = (id) => {
    setRowId(id);
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyChange = (e) => {
    const companyId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectedCompanyId(companyId);

    // Update filterCriteria with the selected company's ID
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));
  };

  const handleRefreshClick = () => {
    getData();
    setfilterCriteria({ date: "", party_name: "" });
    setSelectedCompanyId("");
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            View Private Order Details &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>

          <div className="private-table-container">
            <div className="card-body">
              <div className="table_btn">
                <div
                  className="mb-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <button
                    data-toggle="modal"
                    data-target="#private-local-order"
                    className="btn btn-outline-primary"
                  >
                    <span className="mr-1">
                      <i className="mdi mdi-briefcase-upload" />
                    </span>
                    Add Private Order
                  </button>
                  <button
                    className="btn btn-outline-excel ml-2"
                    onClick={() => exportToExcel(rowData)}
                  >
                    <span className="mr-1">
                      <i className="mdi mdi-file-excel" />
                    </span>
                    Export to Excel
                  </button>
                </div>

                <div
                  style={{
                    marginBottom: "20px",
                  }}
                ></div>
              </div>
              <div className="search mb-3">
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <select
                        className="form-control form-control-lg"
                        onChange={handleCompanyChange}
                        value={selectedCompanyId}
                      >
                        <option value="">Select Company (All)</option>
                        {company &&
                          company?.length > 0 &&
                          company?.map((item, id) => {
                            return (
                              <React.Fragment key={id}>
                                <option
                                  value={item.id}
                                  key={id}
                                >{`${item.company_name}, ${item.location}`}</option>
                              </React.Fragment>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3" style={{ display: "flex" }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by party name"
                      onChange={(e) =>
                        handleFilterChange("party_name", e.target.value)
                      }
                      value={filterCriteria.value}
                    />
                  </div>
                  <div className="col-md-3" style={{ display: "flex" }}>
                    <input
                      type="date"
                      className="form-control"
                      onChange={(e) =>
                        handleFilterChange("date", e.target.value)
                      }
                      value={filterCriteria.date}
                    />
                  </div>
                </div>

                <div
                  className="table-responsive table-bordered govt-table"
                  style={{ border: "0.05px solid lightGray", width: "auto" }}
                >
                  <table className="table">
                    <thead>
                      <tr>
                        <th>S.NO</th>
                        <th>Company Name</th>
                        <th>Product Name</th>
                        <th>Party Name</th>
                        <th>Date</th>
                        <th>Received Date</th>
                        {/* <th style={{ textAlign: "center" }}>Order Details</th> */}
                        <th>Order Quantity</th>
                        <th>Cost</th>
                        <th>Cost (GST Inclusive)</th>
                        <th>Remarks</th>
                        <th style={{ textAlign: "center" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rowData && rowData?.length > 0 ? (
                        rowData &&
                        rowData?.length > 0 &&
                        rowData?.map((item, index) => (
                          <React.Fragment key={index}>
                            <tr>
                              <td style={{ padding: "10px" }}>
                                {(currentPage - 1) * pageSize + index + 1}
                              </td>
                              {/* <td style={{ padding: "10px" }}>{index + 1}</td> */}
                              <td>
                                {item.companyDetails.company_name +
                                  ", " +
                                  item.companyDetails.location}
                              </td>
                              <td>{item?.productName?.size}</td>
                              <td>{item.party_name}</td>
                              <td>{item.date}</td>
                              <td>{item.received_date}</td>
                              {/* <td style={{ padding: "0px" }}>
                              <table style={{ width: "100%" }}>
                                <tbody>
                                  {item.order_details.map(
                                    (orderDetail, orderIndex) => (
                                      <tr key={orderIndex}>
                                        <td>{orderDetail.yard_name}</td>
                                        <td>{orderDetail.company_name}</td>
                                        <td>{orderDetail.size}</td>
                                        <td>{orderDetail.order_qty}</td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </td> */}
                              <td>{item.total_order_qty}</td>
                              <td>{item?.cost}</td>
                              <td>{item?.cost_with_gst ? item?.cost_with_gst: "-"}</td>
                              <td>{item.remarks ? item.remarks : "-"}</td>
                              <td
                                style={{
                                  padding: "10px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                <span>
                                  <button
                                    className="btn btn-outline-secondary btn-sm ml-2"
                                    onClick={() => addDataToModal(item.id)}
                                    data-toggle="modal"
                                    data-target="#update"
                                  >
                                    <i className="mdi mdi-note-edit-outline" />
                                  </button>{" "}
                                  <button
                                    className="btn btn-outline-danger btn-sm ml-2"
                                    onClick={() =>
                                      deleteOrderNumberData(item.id)
                                    }
                                  >
                                    <i className="mdi mdi-delete" />
                                  </button>
                                </span>
                              </td>
                            </tr>
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9">
                            <div className="loading-container">
                              <p>No row to show</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <Pagination
              currentPage={currentPage}
              totalRecords={totalRecords}
              pageSize={pageSize}
              totalPages={totalPages}
              startItem={startItem}
              endItem={endItem}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
            />
            <AddPrivateLocalOrderDetails formRef={formRef} getData={getData} />
            <UpdatePrivateLocalOrderDetail
              rowId={rowId}
              setRowId={setRowId}
              getData={getData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewPrivateLocalDetails;
